import { Link } from "react-router-dom";
import { ROUTES } from "@via/utils/constants.tsx";
import { useLogout } from "@via/api/auth.api.tsx";

interface LoginLinkProps {
  className?: string;
  logoutBeforeLogin?: boolean;
}

const LoginLink: React.FC<LoginLinkProps> = ({
  className = "mt-10",
  logoutBeforeLogin = false,
}) => {
  const { mutate: logout } = useLogout();

  const handleLoginClick = (e: React.MouseEvent) => {
    if (logoutBeforeLogin) {
      e.preventDefault();
      logout();
    }
  };

  return (
    <p className={`${className} text-center text-sm text-gray-500`}>
      Have an account?{" "}
      <Link
        to={ROUTES.LOGIN}
        onClick={handleLoginClick}
        className="font-semibold ml-1 leading-6 text-indigo-600 hover:text-indigo-500">
        Login here
      </Link>
    </p>
  );
};

export default LoginLink;
